module.exports = __webpack_public_path__ + "img/img-2.278b8bee.webp";